module.exports = __webpack_public_path__ + "static/img/top-arrow.f56a2de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top-arrow.png
// module id = DxRA
// module chunks = 1